import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap';

import { modelOf } from '../../../../prop-types';
import PageTitle from '../../../common/PageTitle';
import SEOTitle from '../../../head/SEOTitle';
import HelperNavigation from '../../../common/HelperNavigation';
import globalTranslations from '../../../../i18n/globalTranslations';
import Paths from '../../../../types/Paths';
import RouteService from '../../../../services/RouteService';
import CustomerUserStore from '../../../../store/CustomerUserStore';
import AccountStore from '../../../../store/AccountStore';
import BalanceUserInfo from '../BalanceUserInfo';
import BalanceUserPinCode from '../BalanceUserPinCode';
import RequestState from '../../../../types/RequestState';
import ApiWrapper from '../../../../services/ApiWrapper';

@observer
export class BalanceSubUserAccountOverview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      infoState: RequestState.NONE,
      pinState: RequestState.NONE,
      data: null
    };
  }

  componentDidMount() {
    this.maybeLoadBalanceUser();
  }

  maybeLoadBalanceUser() {
    const { customerUserStore, accountStore } = this.props;

    this.setState({
      infoState: RequestState.LOADING
    });

    customerUserStore
      .loadBalanceUser(accountStore.getUserId)
      .then(() => {
        this.setState({
          infoState: RequestState.LOADED
        });
      })
      .catch((e) => console.error(e));
  }

  handleUserUpdate = () => {
    this.maybeLoadBalanceUser();
  };

  loadPinCode = () => {
    const { apiWrapper } = this.props;

    this.setState({
      pinState: RequestState.LOADING
    });
    apiWrapper.request(`money-transfer/user/account/pin-code`).then((data) => {
      this.setState({
        pinState: RequestState.LOADED,
        data: data
      });
    });
  };

  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccountBalanceSubUser
      }
    ]);
  };

  renderBalanceUserInfo = () => {
    const { accountStore, customerUserStore } = this.props;
    const { infoState, pinState } = this.state;

    const user = customerUserStore.balanceUsers.get(accountStore.getUserId);

    const infoDisabled = infoState === RequestState.LOADING;
    const pinDisabled = pinState === RequestState.LOADING;

    return (
      <Row className="BalanceSubUserAccountOverview__user">
        <Col
          xs="12"
          sm="6"
          className="BalanceSubUserAccountOverview__user-detail"
        >
          <Card>
            <CardHeader>
              <FormattedMessage
                {...globalTranslations.balanceUserAccountInfo}
              />
              <Button
                className="BalanceUserInfo__update"
                onClick={this.handleUserUpdate}
                size="lg"
                disabled={infoDisabled}
              >
                <FormattedMessage {...globalTranslations.update} />
              </Button>
            </CardHeader>
            <CardBody>
              {user && (
                <BalanceUserInfo
                  onInfoUpdate={this.handleUserUpdate}
                  infoState={this.state.infoState}
                  user={user}
                />
              )}
            </CardBody>
          </Card>
        </Col>
        <Col xs="12" sm="6" className="BalanceSubUserAccountOverview__pin-code">
          <Card>
            <CardHeader>
              <FormattedMessage
                id="balanceUser.pinCodeHeader"
                defaultMessage="PIN code"
              />
              <Button
                className="BalanceUserInfo__update"
                onClick={this.loadPinCode}
                size="lg"
                disabled={pinDisabled}
              >
                <FormattedMessage {...globalTranslations.update} />
              </Button>
            </CardHeader>
            <CardBody>
              <BalanceUserPinCode
                pinState={this.state.pinState}
                pinData={this.state.data}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <div className="BalanceSubUserAccountOverview">
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <SEOTitle title={globalTranslations.myAccount} />
        <PageTitle>
          <FormattedMessage {...globalTranslations.myAccount} />
        </PageTitle>
        {this.renderBalanceUserInfo()}
      </div>
    );
  }
}

BalanceSubUserAccountOverview.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  apiWrapper: PropTypes.instanceOf(ApiWrapper).isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired
};

export default injectIntl(
  inject('apiWrapper', 'routeService', 'accountStore', 'customerUserStore')(
    BalanceSubUserAccountOverview
  )
);



// WEBPACK FOOTER //
// ./src/components/my-account/BalanceUser/BalanceSubUserAccountOverview/index.jsx